import { render, staticRenderFns } from "./AccountActivationForm.vue?vue&type=template&id=617dc99f&scoped=true"
import script from "./AccountActivationForm.vue?vue&type=script&lang=js"
export * from "./AccountActivationForm.vue?vue&type=script&lang=js"
import style0 from "./AccountActivationForm.vue?vue&type=style&index=0&id=617dc99f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617dc99f",
  null
  
)

export default component.exports